import * as Dialog from '@radix-ui/react-dialog'
import { Outlet, useRouterState } from '@tanstack/react-router'
import { X } from 'lucide-react'
import { useState } from 'react'
import { Toaster } from 'sonner'
import { TooltipProvider } from '@/components/ui/Tooltip'
import { SemesterProvider } from '@/lib/semester-context'
import { useThema } from '@/lib/theme'
import { Merk, Sidebar, SidebarFooter, SidebarNav } from './Sidebar'
import { Topbar } from './Topbar'

export function AppShell() {
  const routeSleutel = useRouterState({ select: (state) => state.location.pathname })
  const [navOpen, setNavOpen] = useState(false)
  const thema = useThema()

  return (
    <TooltipProvider delayDuration={250}>
      <SemesterProvider>
        <div className="flex h-full">
          <Sidebar />

          <Dialog.Root open={navOpen} onOpenChange={setNavOpen}>
            <Dialog.Portal>
              <Dialog.Overlay className="fixed inset-0 z-40 bg-(--scrim) backdrop-blur-xs lg:hidden" />
              <Dialog.Content className="fixed inset-y-0 left-0 z-50 flex w-64 flex-col bg-surface shadow-pop animate-fade-in lg:hidden">
                <Dialog.Title className="sr-only">Navigatie</Dialog.Title>
                <div className="flex items-center justify-between pr-3">
                  <Merk />
                  <Dialog.Close className="btn-ghost h-8 w-8 p-0" aria-label="Sluiten">
                    <X className="h-4 w-4" />
                  </Dialog.Close>
                </div>
                <SidebarNav onNavigate={() => setNavOpen(false)} />
                <SidebarFooter onNavigate={() => setNavOpen(false)} />
              </Dialog.Content>
            </Dialog.Portal>
          </Dialog.Root>

          <div className="flex min-w-0 flex-1 flex-col">
            <Topbar onOpenSidebar={() => setNavOpen(true)} />
            <main className="flex-1 overflow-y-auto overflow-x-hidden">
              <div
                key={routeSleutel}
                className="mx-auto w-full max-w-6xl animate-fade-up px-4 py-8 lg:px-8"
              >
                <Outlet />
              </div>
            </main>
          </div>

          <Toaster
            position="bottom-right"
            theme={thema}
            toastOptions={{
              style: {
                borderRadius: '12px',
                border: '1px solid var(--hairline)',
                fontSize: '13px',
              },
            }}
          />
        </div>
      </SemesterProvider>
    </TooltipProvider>
  )
}
